import { DropdownChevron } from "@/components/common/Disclosure";
import { Icon, type IconName } from "@/components/common/Icon";

/** 絞り込みメニューを開くアンカーボタン。アイコン・現在の選択ラベル・開閉シェブロンを表示する。 */
export function FilterButton({
	ref,
	icon,
	label,
	open,
	disabled,
	testId,
	onClick,
}: {
	ref: React.RefObject<HTMLButtonElement | null>;
	icon: IconName;
	label: string;
	open: boolean;
	disabled?: boolean;
	testId: string;
	onClick: () => void;
}) {
	return (
		<button
			ref={ref}
			type="button"
			data-testid={testId}
			disabled={disabled}
			className="izanagi-dropdown-trigger"
			onClick={onClick}
		>
			<Icon name={icon} size={14} color="var(--fg-2)" />
			<span
				style={{
					minWidth: 0,
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
				}}
			>
				{label}
			</span>
			<DropdownChevron open={open} size={13} color="var(--fg-2)" />
		</button>
	);
}
